import { atom } from 'recoil';

export const toggleSamRequest = atom({
    key: 'iaas_sql_toggleSamRequest',
    default: false,
});

export const toggleQuickConfig = atom({
    key: 'iaas_sql_toggleQuickConfig',
    default: false,
});

export const defaultVmDataDisk = atom({
    key: 'iaas_sql_defaultVmDataDisk',
    default: undefined,
});
export const isDataDiskLoaded = atom({
    key: 'iaas_sql_isDataDiskLoaded',
    default: false,
});
export const defaultOsDiskType = atom({
    key: 'iaas_sql_defaultOsDiskType',
    default: undefined,
});
export const quickConfigDetails = atom({
    key: 'iaas_sql_quickConfigDetails',
    default: undefined,
});
export const toggleSspModels = atom({
    key: 'iaas_sql_toggleSspModels',
    default: {
        isCost: { costType: '', isCostOpen: false },
        isTagOpen: false,
        isDiskOpen: false,
        isApplicationOpen: false,
        isSubmitOrderSuccess: false,
        isUpdatedToCart: false,
        isCostSplitOpen: false,
        isDataDisk: { isOpen: false, newDataDiskCount: 0, deleteCount: 0 },
        isdisasterRecoveryModal: false,
    },
});

export const isEnvDetailsLoading = atom({
    key: 'iaas_sql_isEnvDetailsLoading',
    default: false,
});

export const isConfigDiskFulfilled = atom({
    key: 'iaas_sql_isConfigDiskFulfilled',
    default: false,
});

export const isMandatoryTagsFullfilled = atom({
    key: 'iaas_sql_isMandatoryTagsFullfilled',
    default: false,
});

export const orderId = atom({
    key: 'iaas_sql_orderId',
    default: '',
});

export const sspSubmitOrder = atom({
    key: 'iaas_sql_sspOrder',
    default: {
        appProfile: null,
        entityDetails: null,
        environment: null,
        appTier: null,
        appTierCode: null,
        microService: null,
        microServiceDetails: null,
        microServiceOptionsAvailable: null,
        region: null,
        regionDisplayName: null,
        appOwner: null,
        appOwnerDetails: null,
        resourceGroup1: null,
        resourceGroupDetails1: null,
        vnetDR1: null,
        vnetDRDetails1: null,
        subnetDR1: null,
        subnetDRDetails1: null,
        osType: null,
        osVersion: null,
        osDiskType: null,
        vmType: null,
        vmTypeDetails: null,
        quantity: 1,
        maxDataDiskCount: null,
        dataDisksCount: null,
        dataDisks: [],
        defaultDataDisks: [],
        adGroup: null,
        hoursOfOperation: null,
        hoursOfOperationDetail: null, // { active: 1, id: '763cf923-85d9-43f7-b338-7be17fded399', name: 'Always ON', type: 'hours_of_operation' },
        timeZone: 'UTC',
        timeZoneDetail: null, // { id: 'd3bb59b6-72b3-49c0-a1c2-c0494ea28802', name: 'UTC', type: 'time_zones', value: 'Default-UTC' }
        domain: null,
        domainDetails: null,
        hCode: null,
        hCodeDetails: null,
        billingEntity: null,
        billingEntityDetails: null,
        adousDefault: null,
        adous: null,
        adousDetails: null,
        sector: null,
        sectorDetails: null,
        tags: [],
        estimatedCost: {
            details: [],
            qty: null,
            totalOneTimeCost: {
                frequency: 'one time cost',
                estCost: null,
                currency: 'USD',
            },
            totalRecurringCost: {
                frequency: 'per item per month',
                estCost: null,
                currency: 'USD',
            },
            notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
        },
        catalogCode: null,
        placeNewOrder: new Date(),
        validationStatus: 'clearValidation',
        isTouched: false,
        haDeployment: null,
        availabilityZone: null,
        availabilityZoneOptions: [],
        retiringServerName: null,
        retiringServerSysId: null,
        databaseName: null,
        serverCollation: 'SQL_Latin1_General_CP1_CI_AS',
        sqlVersion: null,
        serviceInstalled: [],
        disasterRecovery: 'No',
        azureSiteRecovery: 'no',
    },
});

export const environmentDetails = atom({
    key: 'iaas_sql_environmentDetails',
    default: {
        Subscription: '---',
        'DR Priority': '---',
        Resource_Group: '---',
        Metallic_Selection: '---',
        Backup_Tier: '---',
        Virtual_Network: '---',
        // Network_Security_Group: '-',
        Subnet_Name: '---',
        // Application_Security_Group: '-',
        // Recovery_Vault_Name: '---',
        Approval_Manager: '---',
        Project: '---',
        Availability_Set: '---',
    },
});
export const toggleCurrentServer = atom({
    key: 'iaas_sql_toggleCurrentServer',
    default: false,
});

export const CurrentServerDetails = atom({
    key: 'iaas_sql_CurrentServerDetails',
    default: null,
});

export const costEstimateState = atom({
    key: 'iaas-sql-costEstimateState',
    default: null,
});
export const isLoadingCostApiState = atom({
    key: 'iaas-sql-isLoadingCostApiState',
    default: {
        isLoading: false,
    },
});
export const isDBNameValid = atom({
    key: 'iaas-sql-isDBNameValid',
    default: false,
});
export const isExpectedDbSizeValid = atom({
    key: 'iaas-sql-isExpectedDbSizeValid',
    default: false,
});

export const isCostcenterValid = atom({
    key: 'iaas-sql-isCostcenterValid',
    default: false,
});
export const isAppShortNameValid = atom({
    key: 'iaas-sql--isAppShortNameValid',
    default: false,
});

export const isAppShortNameExist = atom({
    key: 'iaas-sql--isAppShortNameExist',
    default: false,
});
